/**
 * PDP sticky offset: keep media-gallery.sticky-content below sticky/fixed top bars.
 * Writes --pdp-sticky-top and --sticky-header-offset on <html>.
 */
(function () {
  const EXTRA = 18;

  function isVisibleTopBar(el, rect) {
    if (!(el instanceof HTMLElement)) return false;
    if (rect.width < window.innerWidth * 0.4) return false;
    if (rect.height <= 0 || rect.height > 280) return false;
    // Stuck / fixed bars sit at (or just above) the viewport top
    if (rect.top > 4 || rect.bottom <= 8) return false;

    const style = getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    if (Number(style.opacity) === 0) return false;

    const pos = style.position;
    return pos === 'fixed' || pos === 'sticky';
  }

  function measure() {
    let bottom = 0;

    const headerSection = document.querySelector('.header-section');
    const headerComponent = document.querySelector('header-component');
    const announcement = document.querySelector('.announcement-bar');

    const primary = [headerSection, headerComponent, announcement].filter(Boolean);
    for (const el of primary) {
      const rect = el.getBoundingClientRect();
      if (!isVisibleTopBar(el, rect)) continue;
      if (rect.bottom > bottom) bottom = rect.bottom;
    }

    // App embeds / countdown bars as direct body children
    for (const el of document.body.children) {
      if (el.id === 'MainContent' || el.id === 'header-group') continue;
      if (el.matches?.('sticky-add-to-cart, footer')) continue;
      const rect = el.getBoundingClientRect();
      if (!isVisibleTopBar(el, rect)) continue;
      if (rect.bottom > bottom) bottom = rect.bottom;
    }

    // Fallback: use CSS vars when nothing measured yet (page top / first paint)
    if (bottom < 1) {
      const styles = getComputedStyle(document.body);
      const headerHeight = parseFloat(styles.getPropertyValue('--header-height')) || 0;
      const groupHeight = parseFloat(styles.getPropertyValue('--header-group-height')) || 0;
      bottom = Math.max(headerHeight, groupHeight, headerHeight + groupHeight * 0.5);
    }

    const px = `${Math.ceil(bottom) + EXTRA}px`;
    document.documentElement.style.setProperty('--pdp-sticky-top', px);
    document.documentElement.style.setProperty('--sticky-header-offset', px);
  }

  let frame = 0;
  function schedule() {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      measure();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  window.addEventListener('load', schedule, { once: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
})();

(function () {
  const TOAST = '.restock-alerts-toast';
  const BTN =
    '.product-details .restock-alerts-notify-button, .product-details .PRODUCT_PAGE-notify-button';
  const SHOW_MS = 5000;
  const watched = new WeakSet();
  const timers = new WeakMap();

  function getButton() {
    return document.querySelector(BTN);
  }

  function getSlot(btn) {
    return btn.closest('.nm-portal, .rm-portal') || btn;
  }

  function isShown(el) {
    if (!el.isConnected) return false;
    if (el.dataset.cwToastState === 'done') return false;
    const style = getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    if (Number(style.opacity) === 0) return false;
    return el.getClientRects().length > 0;
  }

  function setButtonHidden(hidden) {
    document.querySelectorAll('.product-details').forEach((el) => {
      el.classList.toggle('cw-notify-toast-open', hidden);
    });
  }

  function hideAppIcon(el) {
    if (el.dataset.cwToastIconHidden === 'true') return;
    el.dataset.cwToastIconHidden = 'true';
    el.querySelectorAll('svg, img, i').forEach((node) => {
      node.style.setProperty('display', 'none', 'important');
    });

    for (const child of el.children) {
      const style = getComputedStyle(child);
      const rect = child.getBoundingClientRect();
      const text = (child.textContent || '').trim();
      const isIcon =
        (style.position === 'absolute' || style.position === 'fixed') &&
        rect.width <= 48 &&
        rect.height <= 48;
      const isTiny = rect.width <= 40 && rect.height <= 40 && text.length <= 2;
      if (isIcon || isTiny) child.style.setProperty('display', 'none', 'important');
    }
  }

  function applyPlacement(el, btn) {
    hideAppIcon(el);

    const rect = getSlot(btn).getBoundingClientRect();
    const top = `${Math.round(rect.top)}px`;
    const left = `${Math.round(rect.left)}px`;
    const width = `${Math.round(rect.width)}px`;
    const height = `${Math.round(rect.height)}px`;
    const radius = getComputedStyle(btn).borderRadius;

    if (
      el.style.top === top &&
      el.style.left === left &&
      el.style.width === width &&
      el.style.height === height &&
      el.style.visibility === 'visible'
    ) {
      return;
    }

    el.style.setProperty('position', 'fixed', 'important');
    el.style.setProperty('top', top, 'important');
    el.style.setProperty('left', left, 'important');
    el.style.setProperty('right', 'auto', 'important');
    el.style.setProperty('bottom', 'auto', 'important');
    el.style.setProperty('width', width, 'important');
    el.style.setProperty('height', height, 'important');
    el.style.setProperty('max-width', 'none', 'important');
    el.style.setProperty('max-height', 'none', 'important');
    el.style.setProperty('min-width', '0', 'important');
    el.style.setProperty('margin', '0', 'important');
    el.style.setProperty('transform', 'none', 'important');
    el.style.setProperty('z-index', '40', 'important');
    el.style.setProperty('display', 'inline-flex', 'important');
    el.style.setProperty('visibility', 'visible', 'important');
    el.style.setProperty('opacity', '1', 'important');
    el.style.setProperty('pointer-events', 'auto', 'important');
    el.style.setProperty('box-sizing', 'border-box', 'important');
    if (radius) el.style.setProperty('border-radius', radius, 'important');
  }

  function hideToast(el) {
    el.style.setProperty('visibility', 'hidden', 'important');
    el.style.setProperty('opacity', '0', 'important');
    el.style.setProperty('pointer-events', 'none', 'important');
  }

  function resetToast(el) {
    const timer = timers.get(el);
    if (timer) {
      clearTimeout(timer);
      timers.delete(el);
    }
    el.dataset.cwToastState = '';
    el.style.removeProperty('visibility');
    el.style.removeProperty('opacity');
    el.style.removeProperty('pointer-events');
    el.style.removeProperty('display');
  }

  function finish(el) {
    const timer = timers.get(el);
    if (timer) {
      clearTimeout(timer);
      timers.delete(el);
    }
    el.dataset.cwToastState = 'done';
    hideToast(el);

    const stillOpen = [...document.querySelectorAll(TOAST)].some(
      (toast) => toast !== el && toast.dataset.cwToastState === 'active'
    );
    if (!stillOpen) setButtonHidden(false);
  }

  function scheduleFinish(el) {
    if (timers.has(el)) return;
    timers.set(
      el,
      setTimeout(() => finish(el), SHOW_MS)
    );
  }

  function place(el) {
    if (el.dataset.cwToastState === 'done') return;

    const btn = getButton();
    if (!btn) return;

    if (el.dataset.cwToastState !== 'active' && !isShown(el)) return;

    el.dataset.cwToastState = 'active';
    applyPlacement(el, btn);
    setButtonHidden(true);
    scheduleFinish(el);
  }

  function sync() {
    document.querySelectorAll(TOAST).forEach(place);
  }

  function watch(el, force) {
    if (watched.has(el)) return;
    watched.add(el);
    if (force && el.dataset.cwToastState !== 'done') {
      el.dataset.cwToastState = 'active';
    }
    place(el);
    requestAnimationFrame(() => place(el));
    new MutationObserver(() => {
      requestAnimationFrame(() => place(el));
    }).observe(el, { attributes: true, attributeFilter: ['style', 'class'] });
  }

  document.addEventListener(
    'click',
    (event) => {
      if (!event.target.closest?.(BTN)) return;
      document.querySelectorAll(TOAST).forEach(resetToast);
      setButtonHidden(false);
      requestAnimationFrame(() => {
        document.querySelectorAll(TOAST).forEach(place);
      });
    },
    true
  );

  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.(TOAST)) watch(node, true);
        else node.querySelectorAll?.(TOAST).forEach((toast) => watch(toast, true));
      }
      for (const node of record.removedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.(TOAST)) finish(node);
        else node.querySelectorAll?.(TOAST).forEach(finish);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.querySelectorAll(TOAST).forEach(watch);
  window.addEventListener('scroll', sync, { passive: true, capture: true });
  window.addEventListener('resize', sync, { passive: true });
})();
